export const leadStatus = {
    RECEBIDO: 0,
    INTEGRADO: 1,
    FALHANAINTEGRACAO: 2,
    INDISPONIVELPARAINTEGRACAO: 3,
};
